import { USEROLES, DELEGATIONS_SWITCH_CONFIG } from 'common/domain/constants';
import { MODULE_ID as FOOD_BENEFIT_MODULE_ID} from 'food-benefit.module/common/domain/constants';
import { MODULE_ID as VACATIONS_ABSENCES_MODULE_ID} from 'vacations-absences.module/common/domain/constants';

const SWITCH_ID_EMPLOYEE = 0;
const SWITCH_ID_MANAGER = 1;
const MANAGER_PERMISSION = 'A';

class ModalEditDelegationController {
  constructor(DelegationService, EventEmitter, $scope) {
    'ngInject';
    this.DelegationService = DelegationService;
    this.EventEmitter = EventEmitter;
    this.switchOptions = DELEGATIONS_SWITCH_CONFIG;
    this.scope = $scope;
  }

  $onInit() {
    this._initDefaultSwitchOption();
    this.startDate = new Date(this.delegation.startDate);
    this.endDate = new Date(this.delegation.endDate);
    this.dateToSend = {
      startDate: this.startDate,
      endDate: this.endDate,
    };
    this.initStartDate = null;
    this.initEndDate = null;
    this.disableStartDate = true;

    if (this.isMobileApp) {
      this.floatingActionButtons = this.getFloatingActionButtons();
      this.scope.$watch(() => this.form.$invalid, () => {
        this.floatingActionButtons[0].disabled = this.form.$invalid;
      });
    }
  }

  _initDefaultSwitchOption() {
    const delegationEmployeeIsManager = (this.delegation.type === MANAGER_PERMISSION);

    this.option = this.switchOptions[SWITCH_ID_EMPLOYEE].value;
    if (delegationEmployeeIsManager)
      this.option = this.switchOptions[SWITCH_ID_MANAGER].value;
    
    this.delegationType = this.option;
  }

  $postLink() {
    this.setValidRange();
  }

  datepickInitDate({date}) {
    this.startDate = date;
    this.dateToSend = {
      startDate: date,
      endDate: this.endDate,
    };

    let isSameDay = this.isSameDay(date, this.endDate);

    if (!isSameDay && this.dateToSend.startDate > this.dateToSend.endDate) {
      this.form.startDate.$setValidity('validRange', false);
      return;
    }

    this.setValidRange();
  }

  datepickEndDate({date}) {
    this.endDate = date;
    this.dateToSend = {
      startDate: this.startDate,
      endDate: date,
    };

    let isSameDay = this.isSameDay(this.startDate, date);

    if (!isSameDay && this.dateToSend.endDate < this.dateToSend.startDate) {
      this.form.endDate.$setValidity('validRange', false);
      return;
    }

    this.setValidRange();
  }

  send() {
    let event = this.EventEmitter(this.dateToSend);
    this.editDelegation(event);
  }

  setValidRange() {
    if (!this.startDate) {
      this.initStartDate = angular.copy(this.endDate);
    }

    if (!this.endDate) {
      this.initEndDate = angular.copy(this.startDate);
    }

    if (this.form && this.form.endDate) {
      this.form.endDate.$setValidity('validRange', true);
    }

    if (this.form && this.form.startDate) {
      this.form.startDate.$setValidity('validRange', true);
    }
  }

  setButtonDisabled() {
    return this.form.$invalid;
  }

  employeeIsManager() {
    return this.role === USEROLES.MANAGER;
  }

  isFoodBenefitModule() {
    return this.module === FOOD_BENEFIT_MODULE_ID;
  }

  isVacationsAbsencesModule() {
    return this.module === VACATIONS_ABSENCES_MODULE_ID;
  }

  showSwitch() {
    return this.isFoodBenefitModule() && this.employeeIsManager();
  }

  isSameDay(firstDate, secondDate) {
    return firstDate.getFullYear() === secondDate.getFullYear() &&
      firstDate.getMonth() === secondDate.getMonth() &&
      firstDate.getDate() === secondDate.getDate();
  }

  getFloatingActionButtons() {
    return [
      {
        literal: 'GLOBALS.BUTTON_ACTION.SEND'
      }, {
        literal: 'GLOBALS.BUTTON_ACTION.CANCEL'
      }
    ];
  }
}

export default ModalEditDelegationController;



// WEBPACK FOOTER //
// ./client/app/components/modalDelegationManager/modalEditDelegation/modalEditDelegation.controller.js